export default __webpack_public_path__ + "static/media/dark_delete_file_icon.f1dcbead.svg";